import { useState } from 'react';
import styled from 'styled-components';
import { Text, Card, Accordion, AccordionItem } from '@mantine/core';
import TestTransformations from 'components/IntegrationsDashboard/TestingModules/TestTransformation';
import { Editor } from 'components/Editor/TransformationEditor';

const StyledTesting = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  padding: 40px;
`;

const SpaceBetweenCards = styled.div`
  margin-top: 10px;
`;

const initialExtensionDetail = {
  primaryResolver: {
    transformationLogsDto: {
      transformationInput: {},
      transformationOutput: {},
    },
    dataSources: [],
  },
  secondaryResolvers: [
    {
      transformationLogsDto: {
        transformationInput: {},
        transformationOutput: {},
      },
      dataSources: [],
    },
  ],
};

const newEndpointFields = {
  connectorId: '',
  uri: '',
  method: '',
  variables: [],
};

const jsonParse = req => {
  if (!req) return '';
  return JSON.stringify(req, null, 2);
};

const Testing = () => {
  const [extensions, setExtensions] = useState(initialExtensionDetail);
  const onExtensionChange = value => {
    setExtensions(value);
  };

  return (
    <StyledTesting data-testid="testing-dashboard-view">
      <Text size="lg" weight={500} data-testid="testing-heading">
        Testing
      </Text>
      <SpaceBetweenCards />
      <Card>
        <TestTransformations
          data={newEndpointFields}
          onExtensionChange={value => onExtensionChange(value)}
        />
      </Card>

      <SpaceBetweenCards />
      <Text size="lg" weight={500}>
        Logs
      </Text>

      <Accordion multiple={true} defaultValue="default">
        <AccordionItem label="Primary Resolver">
          {extensions?.primaryResolver?.dataSources.length > 0
            ? extensions?.primaryResolver?.dataSources.map(({ request, response }, index) => {
                return (
                  <Accordion multiple={true} defaultValue="default" key={index}>
                    <AccordionItem label={`EndPoint ${index + 1}`}>
                      <Accordion multiple={true} defaultValue="default">
                        <AccordionItem label="Request">
                          <Accordion multiple={true} defaultValue="default">
                            <AccordionItem label="Header">
                              <Editor
                                className="editor__transformation-input"
                                readOnly={true}
                                required={true}
                                value={jsonParse(request.headers)}
                              />
                            </AccordionItem>
                          </Accordion>
                          <Accordion multiple={true} defaultValue="default">
                            <AccordionItem label="Body">
                              <Editor
                                className="editor__transformation-input"
                                readOnly={true}
                                required={true}
                                value={jsonParse(request.body)}
                              />
                            </AccordionItem>
                          </Accordion>
                        </AccordionItem>
                      </Accordion>
                      <Accordion multiple={true} defaultValue="default">
                        <AccordionItem label="Response">
                          <Accordion multiple={true} defaultValue="default">
                            <AccordionItem label="Header">
                              <Editor
                                className="editor__transformation-output"
                                readOnly={true}
                                required={true}
                                value={jsonParse(response.headers)}
                              />
                            </AccordionItem>
                          </Accordion>
                          <Accordion multiple={true} defaultValue="default">
                            <AccordionItem label="Body">
                              <Editor
                                className="editor__transformation-output"
                                readOnly={true}
                                required={true}
                                value={jsonParse(response.body)}
                              />
                            </AccordionItem>
                          </Accordion>
                        </AccordionItem>
                      </Accordion>
                    </AccordionItem>
                  </Accordion>
                );
              })
            : null}
          {extensions?.primaryResolver?.dataSources.length > 0 &&
            extensions?.primaryResolver?.transformationLogsDto?.transformationInput && (
              <Accordion>
                <Accordion.Item label=" Transformation Logs ">
                  <Accordion>
                    <Accordion.Item label=" Input Transformation">
                      <Editor
                        className="editor__transformation-input"
                        readOnly={true}
                        required={true}
                        value={jsonParse(
                          extensions?.primaryResolver?.transformationLogsDto?.transformationInput,
                        )}
                      />
                    </Accordion.Item>
                  </Accordion>
                  <Accordion>
                    <Accordion.Item label=" Output Transformation">
                      <Editor
                        className="editor__transformation-output"
                        readOnly={true}
                        required={true}
                        value={jsonParse(
                          extensions?.primaryResolver?.transformationLogsDto?.transformationOutput,
                        )}
                      />
                    </Accordion.Item>
                  </Accordion>
                </Accordion.Item>
              </Accordion>
            )}
        </AccordionItem>

        <AccordionItem label="Secondary Resolver">
          {extensions?.secondaryResolvers.length > 0
            ? extensions?.secondaryResolvers?.map((secondaryResolver, secondaryIndex) => {
                return (
                  <Accordion multiple={true} defaultValue="default" key={secondaryIndex}>
                    <AccordionItem label={`Secondary ${secondaryIndex + 1}`}>
                      {secondaryResolver?.dataSources.map(({ request, response }, index) => {
                        return (
                          <Accordion multiple={true} defaultValue="default">
                            <AccordionItem label={`EndPoint ${index + 1}`}>
                              <Accordion multiple={true} defaultValue="default">
                                <AccordionItem label="Request">
                                  <Accordion multiple={true} defaultValue="default">
                                    <AccordionItem label="Header">
                                      <Editor
                                        className="editor__transformation-input"
                                        readOnly={true}
                                        required={true}
                                        value={jsonParse(request?.headers)}
                                      />
                                    </AccordionItem>
                                  </Accordion>
                                  <Accordion multiple={true} defaultValue="default">
                                    <AccordionItem label="Body">
                                      <Editor
                                        className="editor__transformation-input"
                                        readOnly={true}
                                        required={true}
                                        value={jsonParse(request?.body)}
                                      />
                                    </AccordionItem>
                                  </Accordion>
                                </AccordionItem>
                              </Accordion>
                              <Accordion multiple={true} defaultValue="default">
                                <AccordionItem label="Response">
                                  <Accordion multiple={true} defaultValue="default">
                                    <AccordionItem label="Header">
                                      <Editor
                                        className="editor__transformation-output"
                                        readOnly={true}
                                        required={true}
                                        value={jsonParse(response?.headers)}
                                      />
                                    </AccordionItem>
                                  </Accordion>
                                  <Accordion multiple={true} defaultValue="default">
                                    <AccordionItem label="Body">
                                      <Editor
                                        className="editor__transformation-output"
                                        readOnly={true}
                                        required={true}
                                        value={jsonParse(response?.body)}
                                      />
                                    </AccordionItem>
                                  </Accordion>
                                </AccordionItem>
                              </Accordion>
                            </AccordionItem>
                          </Accordion>
                        );
                      })}

                      {secondaryResolver?.dataSources.length > 0 &&
                        secondaryResolver?.transformationLogsDto?.transformationInput && (
                          <Accordion>
                            <Accordion.Item label=" Transformation Logs ">
                              <Accordion>
                                <Accordion.Item label=" Input Transformation">
                                  <Editor
                                    className="editor__transformation-input"
                                    readOnly={true}
                                    required={true}
                                    value={jsonParse(
                                      secondaryResolver?.transformationLogsDto?.transformationInput,
                                    )}
                                  />
                                </Accordion.Item>
                              </Accordion>
                              <Accordion>
                                <Accordion.Item label=" Output Transformation">
                                  <Editor
                                    className="editor__transformation-output"
                                    readOnly={true}
                                    required={true}
                                    value={jsonParse(
                                      secondaryResolver?.transformationLogsDto
                                        ?.transformationOutput,
                                    )}
                                  />
                                </Accordion.Item>
                              </Accordion>
                            </Accordion.Item>
                          </Accordion>
                        )}
                    </AccordionItem>
                  </Accordion>
                );
              })
            : null}
        </AccordionItem>
      </Accordion>
    </StyledTesting>
  );
};

export default Testing;
